// extracted by mini-css-extract-plugin
export default {"count":"Like_count__J-9kn","active":"Like_active__P6yMm"};